import script from "./DetailRequestApproved.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailRequestApproved.vue?vue&type=script&setup=true&lang=js"

import "./DetailRequestApproved.vue?vue&type=style&index=0&id=0d9bc26e&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d9bc26e"]])

export default __exports__